import * as React from 'react';
import {useEffect, useRef, useState} from "react";
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useDispatch, useSelector } from 'react-redux';
import {
  Divider,
  IconButton,
  Select,
  Typography,
  FormControl,
  InputLabel,
  MenuItem,
  FormHelperText,
  Container,
  Stack,
  Paper,
  Box,
  FormLabel,
  FormControlLabel,
  Radio,
  RadioGroup,
  Checkbox,
  Switch,
  Badge,
  Tooltip,
} from '@mui/material';
import {findCode, fullCopy, printVariable,download, hashids} from '@util/helper';
import WebService from '@util/webService';
import useSnackbar from '@hooks/useSnackbar';
import useIndicator from '@hooks/useIndicator';
import axios from 'axios';
import { Fragment } from 'react';
import moment from 'moment';
import {Grid} from "@mui/material/";
import useDelegate from "@hooks/useDelegate";
import {styled} from "@mui/material/styles";
import useAlert from "@hooks/useAlert";
import { useParams, useSearchParams } from 'react-router-dom';
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
// quill
import ReactQuill, {Quill} from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import 'react-quill/dist/quill.bubble.css';
import { setSchola } from '@redux/actions/scholaAction';
import ConfirmDialog from "@components/ConfirmDialog";
import { useTheme } from '@mui/material/styles';
import { QuestionMarkTwoTone } from '@mui/icons-material';
import InfoIcon from '@mui/icons-material/Info';
const FormHelperTexts = styled(FormHelperText)`
    width: 100%;
    padding-left: 16px;
    font-weight: 700 !important;
    color: #d32f2f !important;
  `;

const PublicSurveyPage = () =>  {
  const {encSurveyId} = useParams()
  const [searchParams] = useSearchParams()
  const surveyId = hashids.decode(encSurveyId)[0]  
  const userToken = searchParams.get("userToken")
  const userId = hashids.decode(userToken)[0]  
  
  const {alert, renderAlert} = useAlert()
  const [notice, set_notice] = useState({})
  const [openSnackbar, renderSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const [record, set_record] = useState()
  const [allRepls, set_allRepls] = useState([])
  const [dirtyQuests, set_dirtyQuests] = useState({})
  const [saved, set_saved] = useState(null)
  const replsRef = useRef([])
  const dispatch = useDispatch() 
  const theme = useTheme()
  const account = useSelector(state => state.accountReducer);
  
  const fetchSurvey = async() => {
    console.log('fetchSurvey.....')
    // if(!orgId) {
    //   alert('데이터를 가져올 수 없습니다.')
    //   return
    // }
    // const url = `/public/survey/${orgId}`
    const url = `/public/survey/${encSurveyId}/${userToken}`
    openIndicator()
    const resp = await WebService.get(url)
    closeIndicator()
    if(resp.repCode !== 'ack') {
      alert(resp.repMessage) 
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    const records = JSON.parse(repMessage.records)
    const replCount = +repMessage.replCount
    if(replCount > 0) {
      set_saved(true)
    }
    else {
      set_saved(false)
    }
    return records
  }


  const onLoad = async() => {
    
    const records = await fetchSurvey()
    const dateFormat = 'YYYY-MM-DD HH:mm:ss';
    const now = moment().format(dateFormat)
    const repls = []

    if(records && records.length > 0) {
      const record = records[0]
      const school = record.school
      dispatch(setSchola(school))
      console.log('record=>', record)
      
      for(const quest of record.quests) {
        const repl = {
          id: -1,
          userId: userId,
          surveyId: quest.surveyId,
          questId: quest.id,
          ansIds: [],
          txt: '',
          regTime: now,
          uptTime: now,
          //
          sqNum: quest.sqNum,
          questCode: quest.questCode,
          mustYn: quest.mustYn,
        }
        repls.push(repl)
      }

      console.log(`repls=>`, repls)
      set_allRepls(repls)
      set_record(record)
    }
  }

  const validate = () => {
    console.log(`allRepls`, allRepls)
    const repls = []
    let alarm = ''
    for(const repl of allRepls) {
      if(repl.mustYn == 'Y') {
        if(repl.questCode === 'Q000' || repl.questCode === 'Q001') {
          if(repl.ansIds.length == 0) {
            dirtyQuests[repl.questId] = '응답 필수입니다.'
            set_dirtyQuests({...dirtyQuests})

            alarm = `Q.${repl.sqNum} 응답 필수입니다.`
            alert(alarm)

            const element = document.getElementById(`quest-${repl.questId}`);
            if (element) {
              element.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }

            return
          }
          else {
            for(const ansId of repl.ansIds) {
              const d = {...repl, ansId: ansId}
              repls.push(d)
            }
          }
        }
        else {
          if(!repl.txt.trim()) {
            alarm = `Q.${repl.sqNum} 응답 필수입니다.`
            alert(alarm)
            dirtyQuests[repl.questId] = '응답 필수입니다.'
            set_dirtyQuests({...dirtyQuests})

            const element = document.getElementById(`quest-${repl.questId}`);
            if (element) {
              element.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }

            return
          }
          else {
            const d = {...repl, ansId: -1}
            repls.push(d)
          }
        }
      }
      else {
        if(repl.questCode === 'Q000' || repl.questCode === 'Q001') {
          if(repl.ansIds.length > 0) {
            for(const ansId of repl.ansIds) {
              const d = {...repl, ansId: ansId}
              repls.push(d)
            }
          }
        }
        else {
          if(repl.txt.trim()) {
            const d = {...repl, ansId: -1}
            repls.push(d)
          }
        }
      }
    }
    replsRef.current = repls
    console.log('repls=>', replsRef.current)
    return true
  }

  const onDeleteRepl = async() => {
    const url = `/public/survey/repl/${encSurveyId}/user/${userToken}`
    const resp = await WebService.delete(url)
    if(resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
  
    alert('삭제되었습니다.',() => {
      console.log('dddddddddddddddddd')
      window.location.reload()
    })
    
    // openSnackbar('삭제되었습니다.')
  }
  
  const onSubmit = async() => {
    if(replsRef.current.length == 0) {
      return
    }
    const surveyId = replsRef.current[0].surveyId
    
    const url = `/public/survey/repl/${surveyId}`
    const data = {
      surveyRepls: JSON.stringify(replsRef.current)
    }

    console.log('data=>', data)
    openIndicator()
    const resp = await WebService.post(url, data)
    closeIndicator()
    if(resp.repCode != 'ack') {
      alert(resp.repMessage)
      return
    }

    set_saved(true)
    alert('설문제출이 완료되었습니다. 설문조사에 응해 주셔서 감사합니다.')

  }
  
  useEffect(() => {
    onLoad()
  }, [])

  return (
    <Container maxWidth='sm'
      
    >
      {renderSnackbar()}
      {renderIndicator()}
      {renderAlert()}
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Typography style={{fontWeight:'bold', textAlign:'center'}} variant={'h5'}>{record?.title}</Typography>
          {
            saved && record?.statCode === 'R001' ? (
              <>
                <Typography style={{fontWeight:'bold', textAlign:'center'}} variant={'body2'} color={theme.palette.secondary.main}>
                  이 설문조사에 제출이 완료되었습니다.
                </Typography>
                <ConfirmDialog
                btn={
                <Button variant='contained' 
                  color='warning'
                  onMouseOver={() => {
                    document.activeElement?.blur();
                  }}
                > 
                  내 응답 삭제
                </Button>
                }
                title={'설문 응답 삭제'}
                content={'제출한 설문 응답을 삭제하시겠습니까?'}
                bc={'warning'}
                preHandle={ async () => {
                  return true
                }}
                perform={() => {
                  onDeleteRepl()
                }}
              />
                {
                  // 로그인한 사용자만 삭제버튼 보이게
                  // account?.user?.id ? (
                  //   <Stack style={{display:'flex', flexDirection:'row', alignItems:'center',  padding:5}}>
                  //     <Badge
                  //       sx={{
                  //         '& .MuiBadge-badge': {
                  //           // backgroundColor: '#fff',
                  //           backgroundColor: 'transparent',
                  //           // border: '1px dotted #9e9e9e', 
                  //           color: '#fff',
                  //           transform: 'none',
                  //           // top: '-20px',          // nudge upward
                  //           right: '-25px',   
                  //           // right: 0,
                  //           top: 0,
                  //           display: 'flex',
                  //           justifyContent: 'flex-end', // horizontal alignment
                  //           alignItems:'center'
                  //         },
                  //       }}
                  //       anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                  //       badgeContent={
                  //         <Tooltip arrow title="설문제출하고 브라우저로 로그인한 사용자에게만 보이는 버튼입니다, 모일일 앱에서 브라우저로 단순히 링크된 경우에는 보이지 않습니다.">
                  //           <InfoIcon sx={{ color: '#ab47bc'}}/>
                  //         </Tooltip>
                  //       }
                  //     >

                      
                  //     <Button
                  //       variant={'contained'}
                  //       color={'warning'}
                  //       onClick={() => {
                  //         onDeleteRepl()
                  //       }}
                  //     >
                  //       내 응답 삭제
                  //       </Button>
                  //     </Badge>
                  //   </Stack>
                     
                  // ) : null
                }
               
              </>
              
            ) : null
          }
        </Grid>
        {
          record?.statCode === 'R001' ? (
            <>
             <Grid item xs={12}>
          <Typography variant='body2' sx={{whiteSpace:'pre-line', color:'#424242'}}>{record?.content} </Typography>
        </Grid>
        <Grid item xs={12}>
        
        {
          
          record?.quests.map((quest, idx) => (
            <Stack id={`quest-${quest.id}`} style={{backgroundColor:'#eee', padding:20, paddingTop: idx == 0 ? 20 : 0}}>
              <Paper elevation={1} style={{backgroundColor:'#fff', padding:10}}>
                <Grid container spacing={1}>
                <Grid item xs={12} style={{display:'flex', flexDirection:'column',}}>
                  <Typography key={idx} style={{fontWeight:'bold'}}>
                    Q {quest.sqNum}. {quest.txt}
                  </Typography>
                  {
                    (() => {
                      let expl = quest.mustYn === 'Y' ? '응답필수': '' 
                      expl +=  quest.questCode === 'Q001' ? ', 복수선택가능': ''
                      if(expl) {
                        return (
                          <Typography variant='body2'>{`(${expl})`}</Typography>
                        )
                      }
                      
                    })()
                  }
                  
                </Grid>
                <Grid item xs={12}>
                  <Grid container spacing={1}>
                    {
                      <Grid item xs={12}>
                          {
                            quest.questCode === 'Q000' ? (
                              <FormControl>
                                <RadioGroup
                                  aria-labelledby={`q_${idx}`}
                                  name={`q_${idx}`}  
                                  onChange={e => {
                                    const found = allRepls.find(r => r.questId === quest.id)
                                    if(found) {
                                      found.ansIds = []
                                      found.ansIds.push(+e.target.value)
                                      dirtyQuests[quest.id] = ''
                                      set_dirtyQuests({...dirtyQuests})
                                    }
                                  }}
                                >
                                  {
                                    quest.anss?.map((ans, idx2) => (
                                      <FormControlLabel  key={ans.id} value={ans.id} control={<Radio />} label={ans.txt}  />
                                    ))
                                  }
                                </RadioGroup>
                              </FormControl>
                            ) : quest.questCode === 'Q001' ? (
                              <FormControl>
                                {
                                  quest.anss?.map((ans, idx2) => (
                                    <FormControlLabel
                                      key={ans.id}
                                      control={
                                        <Checkbox 
                                          color="primary"
                                          name={ans.id}
                                          value={ans.id}
                                          onChange={e => {
                                            const found = allRepls.find(r => r.questId === quest.id)
                                            if(found) {
                                              const ridx = found.ansIds.indexOf(+e.target.value)
                                              if(e.target.checked) {
                                                if(ridx < 0) {
                                                  found.ansIds.push(+e.target.value)
                                                }
                                              }
                                              else {
                                                if(ridx >= 0) {
                                                  found.ansIds.splice(ridx, 1)
                                                }  
                                              }
                                            }

                                            if(found.ansIds.length == 0) {
                                              if(quest.mustYn === 'Y') {
                                                dirtyQuests[quest.id] = '응답 필수입니다.'
                                              }
                                            }
                                            else {
                                              dirtyQuests[quest.id] = ''
                                            }
                                            set_dirtyQuests({...dirtyQuests})
                                          }}
                                          
                                        />
                                      }
                                      label={ans.txt}
                                    />
                                  ))
                                }
                               
                                
                              </FormControl>
                            ) : (
                              <TextField
                                label={''}
                                fullWidth
                                multiline
                                rows={4}
                                name={'content'}
                                onChange={e => {
                                  const found = allRepls.find(r => r.questId === quest.id)
                                  if(found) {
                                    found.txt = e.target.value
                                    if(found.txt.trim().length == 0) {
                                      dirtyQuests[quest.id] = '응답 필수입니다.'
                                    }
                                    else {
                                      dirtyQuests[quest.id] = ''
                                    }
                                    set_dirtyQuests({...dirtyQuests})
                                  }
                                }}
                                
                              />
                            )
                          }
                           
                        </Grid>
                    }
                  </Grid>
                  <FormHelperTexts>{dirtyQuests[quest.id]}</FormHelperTexts>
                </Grid>
              </Grid>
              </Paper>
              
            </Stack>
          ))
        }
        </Grid>
        {
          saved !== null ? (
            <Grid item xs={12} style={{display:'flex', justifyContent:'center', flex:1,}}>
              {/* <Button disabled={saved} style={{marginRight:10}}>다시 작성</Button> */}
              <ConfirmDialog
                btn={
                <Button variant='contained' 
                  disabled={saved}
                  onMouseOver={() => {
                    document.activeElement?.blur();
                  }}
                > 
                  설문제출
                </Button>
                }
                title={'설문제출'}
                content={'설문을 제출하시겠습니까?'}
                bc={'primary'}
                preHandle={ async () => {
                  return validate()
                }}
                perform={() => {
                  onSubmit()
                }}
              />
            </Grid>
          ) : null
        }
            </>
          ) : (
            saved !== null ? (
              <Grid item xs={12}>
              <Typography variant={'h6'} textAlign={'center'}>
                해당 설문조사는 게시 중이 아닙니다.
              </Typography>
            </Grid>
            ) : null
            
          )
        }
       
        
      </Grid>
     
    </Container>
  )
}

export default PublicSurveyPage
